var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.tag,{tag:"component"},[_c('span',{ref:"contentEl",style:(_setup.clampStyle)},[_vm._t("default")],2),_vm._t("after",null,{"expanded":_setup.localExpanded,"clamped":_setup.isClamped,"toggle":_setup.toggle,"expand":_setup.expand,"collapse":_setup.collapse})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }